import { render } from "./imgWrap.vue?vue&type=template&id=5641e828&scoped=true"
import script from "./imgWrap.vue?vue&type=script&lang=js"
export * from "./imgWrap.vue?vue&type=script&lang=js"

import "./imgWrap.vue?vue&type=style&index=0&id=5641e828&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641e828"]])

export default __exports__